import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import {
	FireInsuranceBrokeragesSearchState,
	FireInsuranceBrokerageDispatch,
} from '@state/algolia-search/fire-insurance-brokerages-search';
import { combineLatest, Observable } from 'rxjs';
import { FireInsuranceBrokerage } from '@models/brokerage';
import { map } from 'rxjs/operators';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { TestHooks } from './search-fire-insurance-brokerage.hooks';

export enum DropdownSelect {
	SELECT_FIRE_INSURANCE_BROKERAGE = 'SELECT_FIRE_INSURANCE_BROKERAGE',
}

@UntilDestroy()
@Component({
	selector: 'app-search-fire-insurance-brokerage-input',
	templateUrl: './search-fire-insurance-brokerage.component.html',
	standalone: false,
})
export class SearchFireInsuranceBrokerageComponent implements OnInit {
	testHooks = TestHooks;
	public fireInsuranceBrokerageName = '';
	public ICON = ICON;
	public showDropdown = false;
	public dropdownSelect = DropdownSelect;
	public loading = false;

	@Input() label = '';

	@Output() onFocus = new EventEmitter();
	@Output() onCreate = new EventEmitter<string>();
	@Output() onSelect = new EventEmitter<
		DropdownResult<FireInsuranceBrokerage>
	>();

	@Select(FireInsuranceBrokeragesSearchState.getList)
	fireInsuranceBrokerage$: Observable<FireInsuranceBrokerage[]>;

	ngOnInit() {
		combineLatest([this.fireInsuranceBrokerage$])
			.pipe(
				untilDestroyed(this),
				map(() => {
					this.loading = false;
				}),
			)
			.subscribe();
	}

	constructor(
		private fireInsuranceBrokerageDispatch: FireInsuranceBrokerageDispatch,
	) {}

	_onFocus() {
		this.onFocus.emit();
	}

	create() {
		this.onCreate.emit(this.fireInsuranceBrokerageName);
	}

	search = ($event) => {
		this.loading = true;
		this.fireInsuranceBrokerageDispatch.Search($event);
	};

	onSelectFireInsuranceBrokerage = (
		ev: DropdownResult<FireInsuranceBrokerage>,
	) => {
		if (ev.groupType === DropdownSelect.SELECT_FIRE_INSURANCE_BROKERAGE) {
			this.onSelect.emit(ev);
		}
	};
}
